import LoadingSpinner from "../library/loading-spinner/LoadingSpinner";
import auth from "../user/services/Auth";
import UserRoleValidator from "../user/UserRoleValidator";
import { useEffect } from "react";
interface PropsModel {
    children: React.ReactNode
    validatorName: string
}
const PrivateRoute = (props: PropsModel) => {
    const { children, validatorName } = props;
    // const userData = useSelector((state) => state.user, shallowEqual);

    const renderRoute = () => {
        if (auth.isAuthenticated()) {
            return <UserRoleValidator validatorName={validatorName}>{children}</UserRoleValidator>;
        }

        // auth.login();

        return <LoadingSpinner />;
    };

    useEffect(() => {
        if (!auth.isAuthenticated()) auth.login();
    }, []);

    return renderRoute();
};

export default PrivateRoute;
